import React from 'react'
import styles from './CompanyInfoTable.module.scss';
import Text from '../atoms/Text';

type Props = {
    title: string,
    table: Array<tableType>
}

type tableType = {
    position: string,
    name_jp: string
}

const CompanyInfoTable = (props: Props) => {
    return (
        <div className={styles.CompanyInfoTable}>
        <Text color='default' size='18' className={styles.title} >{ props.title }</Text>
        <ul>
        {props.table.map(n => 
            <li className={styles.item}>
                <Text color='default' size='18' className={styles.position} >{n.position}</Text>
                <Text color='default' size='18' className={styles.name} >{n.name_jp}</Text>
            </li>
        )}
        </ul>
      </div>
    )
}

export default CompanyInfoTable;